import React from 'react';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import ContestNoticeEditForm, {IContestNoticeEditForm} from '../../../components/ContestNotice/EditForm';
import UseContestNotice from '../../../hooks/apis/useContestNotice';
import {Breadcrumb, Card, message} from 'antd';
import QuickRouter from '../../../utils/QuickRouter';
import UseKnowledgeBank from '../../../hooks/apis/useKnowledgeBank';
import useContestNotice from '../../../hooks/apis/useContestNotice';
import moment from 'moment';
import {useMount} from 'react-use';
import useAuth from '../../../utils/AuthContext';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import useQuickRouter from '../../../utils/QuickRouter';
import {useParams} from 'react-router-dom';

export default function ManageContestNoticeEditPage() {
  const auth = useAuth();
  const saveState = UseContestNotice.save();
  const params = useParams() as {contestId?: string; id?: string};
  const contestId = parseInt(params?.contestId || '');
  const queryById = useContestNotice.queryById();
  const routeQueryId = params?.id || '';
  const quickRouter = useQuickRouter();

  function refresh() {
    queryById
      .request({
        id: parseInt(routeQueryId),
      })
      .then()
      .catch(CommonApiErrorHandler);
  }

  function save(form: IContestNoticeEditForm) {
    saveState
      .request({...form, publishedDate: form.publishedDate.format(), contestId})
      .then(() => {
        message.success('操作成功');
        return quickRouter.manageContestNoticeList(contestId);
      })
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Breadcrumb className={'mb-md'}>
        <Breadcrumb.Item>
          <a onClick={quickRouter.index}>首页</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a onClick={() => quickRouter.manageContestNoticeList(contestId)}>通知列表</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card title={'通知编辑'}>
        <ContestNoticeEditForm
          form={queryById.data ? {...queryById.data, publishedDate: moment(queryById.data?.publishedDate)} : undefined}
          isLoading={saveState.loading}
          onFinish={save}
        />
      </Card>
    </div>
  );
}
